module.exports = __webpack_public_path__ + "img/teacher-qrcode.d5b8bcd8.png";